import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Z_INDEX } from '@/constants/zIndex';

/* 좌측 하단 채널톡 런처(left/bottom 24px, 56px)와 겹치지 않게 그 위에 띄운다. */
const SIDE_GAP = 24;
const CHANNEL_TALK_SIZE = 56;
const CHANNEL_TALK_GAP = 16;

const CARD_WIDTH = 320;
/* 뒤쪽 카드가 위로 삐져나오는 정도(겹쳐 쌓인 것이 보이도록) */
const DEPTH_OFFSET = 16;
const DEPTH_SCALE = 0.05;
/* 스택 내부 순서용 값(전역 z-index가 아닌 컨테이너 안에서의 순서) */
const STACK_LAYER = 10;

export const BannerStack = styled.div`
  position: fixed;
  bottom: ${SIDE_GAP + CHANNEL_TALK_SIZE + CHANNEL_TALK_GAP}px;
  left: ${SIDE_GAP}px;
  z-index: ${Z_INDEX.floatingBanner};

  width: ${CARD_WIDTH}px;
`;

/* depth 0(최신)이 가장 앞에 오고, 이전 버전은 뒤로 겹쳐 쌓인다. */
export const CardSlot = styled.div<{ depth: number }>`
  z-index: ${({ depth }) => STACK_LAYER - depth};

  ${({ depth }) =>
    depth === 0
      ? css`
          position: relative;
        `
      : css`
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          transform: translateY(${-DEPTH_OFFSET * depth}px)
            scale(${1 - DEPTH_SCALE * depth});
          transform-origin: bottom center;
        `}
`;
